import BPReqAccountWithBalance from '@atoms/BPReqAccountWithBalance';
import React from 'react';
import { logAccountChange } from './analyticsBPAccountSelector';

interface PaymentMethod {
  id: string;
  name: string;
  label: string;
  value: string;
  isDisabled?: boolean;
}

interface BPReqData {
  productCode: string;
}
export function dropDownRenderItem(selectedEligibleAccount: PaymentMethod) {
  return (item: PaymentMethod) => (
    <BPReqAccountWithBalance selectedEligibleAccount={selectedEligibleAccount} item={item} showChecked />
  );
}

export function dropDownRenderLeftIcon(selectedEligibleAccount: PaymentMethod) {
  return () => (
    <BPReqAccountWithBalance
      selectedEligibleAccount={selectedEligibleAccount}
      item={selectedEligibleAccount}
      showChecked={false}
    />
  );
}

export function dropDownOnChange(
  setSelectedEligibleAccount: (account: PaymentMethod) => void,
  setSelectedBPAccount: (account: PaymentMethod) => void,
  employeeId: string,
  tcid: string,
  pCode: string,
  source: string,
  bpReqData: BPReqData,
  validatedReferralCode: string,
) {
  return (item: PaymentMethod) => {
    if (!item.isDisabled) {
      logAccountChange(employeeId, tcid, pCode, source, bpReqData, item, validatedReferralCode);
      setSelectedEligibleAccount(item);
      setSelectedBPAccount(item);
    }
  };
}
